<template>
  <div style="margin-right: 1em;">
    <div class="form-row">
      <div class="form-group col-6">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $t('resource.format.label') }}
        </label>
        <p class="label-help">
          {{ $t('resource.format.help') }}
        </p>
        <ValidatedFileFormatSelector
          :required="isRequired"
          validation-name="Format Href"
          @select="$event => form.format = $event"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          URL
        </label>
        <p>{{ $t('resource.url.help') }}</p>
        <p v-if="form.format!=null && form.format.codename.indexOf('ogc-') !== -1">
          Si c'est une couche OGC, renseignez l'URL du service GetCapabilities
        </p>
        <ValidationProvider
          v-slot="{ classes, errors }"
          name="URL"
          :rules="`${isRequired ? 'required' : ''}`"
        >
          <div
            class="control"
            :class="isRequired ? classes : ''"
          >
            <input
              v-model="form.href"
              v-sanitize
              class="form-control"
              type="text"
              placeholder="https://"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>

import ValidatedFileFormatSelector from '@/common/components/ValidatedFileFormatSelector.vue';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'HrefCreator',

  components: {
    ValidatedFileFormatSelector,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    isMain: {
      type: Boolean,
      default: true
    },
  },

  data() {
    return {
      isRequired: true,
      form: {
        type: 'href',
        format: null,
        // scheduler: null,
        href: null
      }
    };
  },


  watch: {
    required(newValue) {
      this.isRequired = newValue;
    },
    form: {
      deep: true,
      handler(newValue) {
        if (newValue.format || newValue.href) {
          this.setRequired(true);
        } else {
          this.setRequired(false);
        }
      }
    },
    'form.href': function() {
      this.setResourceURL();
    },
    'form.format': function() {
      this.setResourceURL();
    }
  },

  created() {
    this.isRequired = this.required;

  },

  methods: {


    setRequired(e) {
      this.isRequired = e;
      this.$emit('set', {
        required: this.isRequired
      });
    },

    setResourceURL() {
      this.$emit('set', {
        form: this.form,
        required: this.isRequired
      });
    }
  }
};
</script>
